module.exports = __webpack_public_path__ + "75b279d6000506bd6ac0df86bca4faf9.png";